<app-header [showToggle]="false" [showSignin]="true"></app-header>

<main id="main" class="main">

  <header class="masthead" area>

    <ul class="circles">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>

    <div class="container position-relative">
      <div class="row justify-content-center">
        <div class="col-xl-10">
          <div class="text-center text-white">

            <h1 class="mb-5 custom-header header-text"><i class="bi-lightning m-auto text-primary text-white"></i>Index like Lightning, Rank Ahead!</h1>

            <h5 class="mb-5">Get ready to boost your web presence, increase visibility, and stay ahead of the competition. Start your journey towards faster Google Indexing today!</h5>

            <button type="button" class="btn btn-primary btn-lg" (click)="routeToSignin()">Get Started</button>
          </div>
        </div>
      </div>
    </div>
  </header>

  <section class="showcase section-ph">
    <div class="container container-small">
      <div class="row p-5">
        <div class="col-lg-6 text-center">
          <a href="https://www.producthunt.com/posts/rank-ahead?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-rank&#0045;ahead" target="_blank">
            <img loading="lazy" src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=434909&theme=light" alt="Rank&#0032;Ahead - A&#0032;SaaS&#0032;for&#0032;faster&#0044;&#0032;autopilot&#0032;website&#0032;indexing&#0032;on&#0032;Google | Product Hunt" style="width: 250px; height: 54px;" width="250" height="54" />
          </a>
        </div>
        <div class="col-lg-6 text-center col-mobile-padding-20">
          <div class="row">
            <div class="col-lg-6 pt-2">
              <span class="img-container">
                <img loading="lazy" src="../../assets/img/profile1.jpg" alt="Profile" class="rounded-circle img-people" width="40">
              </span>
              <span class="img-container">
                <img loading="lazy" src="../../assets/img/profile2.jpg" alt="Profile" class="rounded-circle img-people" width="40">
              </span>
              <span class="img-container">
                <img loading="lazy" src="../../assets/img/profile3.jpg" alt="Profile" class="rounded-circle img-people" width="40">
              </span>
              <span class="img-container">
                <img loading="lazy" src="../../assets/img/profile4.jpg" alt="Profile" class="rounded-circle img-people" width="40">
              </span>
            </div>
            <div class="col-lg-6 col-mobile-padding-5 p-1">
              <div class="row">
                <div class="col">
                  <i class="bi bi-star-fill h5 text-warning"></i>
                  <i class="bi bi-star-fill h5 text-warning"></i>
                  <i class="bi bi-star-fill h5 text-warning"></i>
                  <i class="bi bi-star-fill h5 text-warning"></i>
                  <i class="bi bi-star-fill h5 text-warning"></i>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>Trusted by People</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="showcase">
    <div class="container container-medium text-center mt-5">
      <div class="div-main-video">
        <!--<img class="img-main-video img-fluid rounded-3" src="../../assets/img/fast google indexing.webp" />-->
        <video controls id="guide-video" [ngClass]="{'img-main-video': isVideoPlaying == false}">
          <source src="../../assets/img/202401190912.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <button type="button" class="btn btn-primary d-none d-lg-block" (click)="playVideo()" *ngIf="!isVideoPlaying">
          <i class="bi bi-play h1"></i>
        </button>
      </div>
    </div>
  </section>



  <section class="features-icons bg-light text-center">
    <div class="container">
      <div class="row">
        <div class="col-lg-3">
          <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
            <div class="features-icons-icon d-flex"><i class="bi-lightning m-auto text-primary"></i></div>
            <h3>Faster Indexing</h3>
            <p class="lead mb-0">Get indexed less than 48 hours. Faster indexing means your pages appear in search results more quickly.</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
            <div class="features-icons-icon d-flex"><i class="bi-list-check m-auto text-primary"></i></div>
            <h3>Effortless Bulk Indexing</h3>
            <p class="lead mb-0">Save time and streamline your SEO strategy with our Effortless Bulk Indexing feature.</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="features-icons-item mx-auto mb-0 mb-lg-3">
            <div class="features-icons-icon d-flex"><i class="bi-robot m-auto text-primary"></i></div>
            <h3>Auto Page Indexing</h3>
            <p class="lead mb-0">With our Auto Indexing feature, you can put your website's Google indexing on autopilot.</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="features-icons-item mx-auto mb-0 mb-lg-3">
            <div class="features-icons-icon d-flex"><i class="bi-activity m-auto text-primary"></i></div>
            <h3>SEO Health Check</h3>
            <p class="lead mb-0">Boost your website's SEO! Our SEO Health Check feature provides quick page health checks for optimal performance.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="showcase text-center bg-light">
    <div class="container">
      <h2>Testimonials</h2>
      <div class="row justify-content-center py-3">
        <div class="col-lg-4">
          <div class="card testimonial-card">
            <div class="px-2 py-2">
              <p class="maintxt">Rank Ahead revolutionized the way I approach SEO. Within days of using their tool, my website's new pages were indexed on Google, giving my business an instant boost in visibility. Faster indexing under 48 hours, highly recommended!</p>
              <div class="d-flex justify-content-center mt-2">
                <div><img src="../../assets/img/profile6.jpg" width="50" class="rounded-circle img-fluid"></div>
                <div class="m-4">
                  <span class="name">Craig M. - Digital Marketer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card testimonial-card">
            <div class="px-2 py-2">
              <p class="maintxt">I was skeptical at first, but Rank Ahead exceeded my expectations. Their Bulk URL Submission feature allowed me to submit multiple pages for indexing with just a few clicks. It's a game-changer for anyone serious about SEO.</p>
              <div class="d-flex justify-content-center mt-2">
                <div><img src="../../assets/img/profile8.jpg" width="50" class="rounded-circle"></div>
                <div class="m-4">
                  <span class="name">Emily H. - Blogger</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card testimonial-card">
            <div class="px-2 py-2">
              <p class="maintxt">I've tried numerous indexing tools in the past, but none compare to Rank Ahead. Their commitment to delivering fast and reliable indexing is unmatched. If you want your website to rank higher on Google, look no further.</p>
              <div class="d-flex justify-content-center mt-2">
                <div><img src="../../assets/img/profile5.jpg" width="50" class="rounded-circle"></div>
                <div class="m-4">
                  <span class="name"> David L. - SEO Specialist</span>
                  <!--<p class="para">Company name</p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card testimonial-card">
            <div class="px-2 py-2">
              <p class="maintxt">Rank Ahead has become an essential part of my SEO strategy. Their platform is user-friendly, and their support team is always responsive. Thanks to their Faster Indexing feature, I've seen a significant improvement in my website's search engine rankings.</p>
              <div class="d-flex justify-content-center mt-2">
                <div><img src="../../assets/img/profile7.jpg" width="50" class="rounded-circle"></div>
                <div class="m-4">
                  <span class="name">Jessica W. - Blogger</span>
                  <!--<p class="para">Company name</p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card testimonial-card">
            <div class="px-2 py-2">
              <p class="maintxt">I can't imagine managing my website without Rank Ahead. Their tool simplifies the indexing process, allowing me to focus on creating quality content. Whether you're a novice or experienced webmaster, Rank Ahead is a must-have tool in your arsenal.</p>
              <div class="d-flex justify-content-center mt-2">
                <div><img src="../../assets/img/profile11.jpg" width="50" class="rounded-circle"></div>
                <div class="m-4">
                  <span class="name">Ryan P. - Web Developer</span>
                  <!--<p class="para">Company name</p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card testimonial-card">
            <div class="px-2 py-2">
              <p class="maintxt">Amazing tool! Best $10 a month I spend on my website. Helps me automatically index thousands of pages a month. With their innovative approach to indexing, my website saw a noticeable increase in organic traffic within a matter of weeks.</p>
              <div class="d-flex justify-content-center mt-2">
                <div><img src="../../assets/img/profile10.jpg" alt="profile" width="50" class="rounded-circle"></div>
                <div class="m-4">
                  <span class="name">Alex D. - Blogger</span>
                  <!--<p class="para">Company name</p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="showcase">
    <div class="container-fluid p-0 mt-lg-5">
      <div class="row g-0">
        <div class="col-lg-6 order-lg-2 text-white showcase-img" style="background-image: url('../../assets/img/fast google indexing.webp')">
        </div>
        <div class="col-lg-6 order-lg-1 my-auto showcase-text">
          <h2>Faster Google Indexing</h2>
          <p class="lead mb-0">In the fast-paced digital landscape, staying relevant is essential. With faster Google indexing, your content is discovered sooner, keeping you competitive in your industry.</p>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-6 text-white showcase-img" style="background-image:url('../../assets/img/submit bulk urls.webp')"></div>
        <div class="col-lg-6 my-auto showcase-text">
          <h2>Simplify Indexing with Bulk URL Submissions</h2>
          <p class="lead mb-0">Save time and streamline your SEO strategy with our Effortless Bulk Indexing feature. Submit multiple URLs at once, and watch as our powerful tools ensure rapid inclusion in Google's search results. Take control of your web presence and enjoy lightning-fast results.</p>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-6 order-lg-2 text-white showcase-img" style="background-image: url('../../assets/img/auto-indexing.webp')"></div>
        <div class="col-lg-6 order-lg-1 my-auto showcase-text">
          <h2>Set it and Forget it with Auto Indexing</h2>
          <p class="lead mb-0">With our Auto Indexing feature, you can put your website's Google indexing on autopilot. Simply activate this feature, and our system will continuously monitor and index your new pages as they're created. Say goodbye to manual indexing and enjoy effortless SEO management.</p>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-6 text-white showcase-img" style="background-image: url('../../assets/img/indexing history.webp')"></div>
        <div class="col-lg-6 my-auto showcase-text">
          <h2>Indexing History</h2>
          <p class="lead mb-0">Explore Your Progress: With our Indexing History feature, you can effortlessly track the status of your submitted URLs and see if they've been successfully indexed by Google.</p>
        </div>
      </div>
      <div class="row g-0">
        <div class="col-lg-6 order-lg-2 text-white showcase-img" style="background-image: url('../../assets/img/seo health check.webp')"></div>
        <div class="col-lg-6 order-lg-1 my-auto showcase-text">
          <h2>SEO Health Check</h2>
          <p class="lead mb-0">Elevate your site's SEO game effortlessly! Uncover insights with our SaaS feature. Check website title, meta description, Social Media Meta Tags, and headings. More tools on the horizon for comprehensive optimization!</p>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
